package com.yogaaicoach.common.ui.components

import react.ChildrenBuilder
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.ClassName

// Pixel-matched against StepProgressIndicator.kt: a row of step circles (icon, or a checkmark
// once past) connected by lines, current/past steps highlighted in primary, future steps dimmed.
internal fun ChildrenBuilder.StepProgressIndicator(currentStep: Int, stepIcons: List<react.FC<Props>>) {
    div {
        className = ClassName("step-progress-indicator")
        stepIcons.forEachIndexed { index, icon ->
            val step = index + 1
            StepCircle(step, currentStep, icon)
            if (index < stepIcons.lastIndex) {
                div {
                    className = ClassName(if (step < currentStep) "step-connector step-connector-done" else "step-connector")
                }
            }
        }
    }
}

private fun ChildrenBuilder.StepCircle(step: Int, currentStep: Int, icon: react.FC<Props>) {
    val state = when {
        step < currentStep -> "past"
        step == currentStep -> "current"
        else -> "future"
    }
    div {
        className = ClassName("step-circle step-circle-$state")
        if (state == "past") {
            CheckIconGradient {}
        } else {
            icon {}
        }
    }
}
